// extracted by mini-css-extract-plugin
module.exports = {"gallery":"styles_gallery__2ghj7","button":"styles_button__3f_FS"};